import { useAct } from 'FlowBuilder/store'
import './TopNav.scoped.scss'
import { toast } from 'react-toastify'
import LanguageSelector from './LanguageSelector'

export default function TopNav() {
  const act = useAct()
  const navItem = useSel(s => s.local.navItem)
  const isEditingTemplate = useSel(s => s.local.isEditingTemplate)
  const buildValidationErrors = useSel((s) => s.builder.validationErrors || [])
  const setupValidationErrors = useSel((s) => s.builder.setupValidationErrors || [])
  const templateValidationErrors = useSel((s) => s.builder.templateValidationErrors || [])

  const hasBuildValidationErrors = () => {
    return isEditingTemplate && buildValidationErrors.length > 0
  }

  const hasSetupValidationErrors = () => {
    return setupValidationErrors.length > 0
  }

  const hasTemplateValidationErrors = () => {
    return templateValidationErrors.length > 0
  }

  const changeTab = (newPage) => {
    if (navItem === 'build' && buildValidationErrors.length > 0) {
      buildValidationErrors.forEach(error => {
        toast.error(error)
      })
      return new Error('Build validation errors present')
    }
    if (navItem === 'template' && isEditingTemplate && templateValidationErrors.length > 0) {
      templateValidationErrors.forEach(error => {
        toast.error(error)
      })
      return new Error('Template validation errors present')
    }
    act.local.setNav(newPage)
  }

  const tabClasses = (tab) => {
    let classes = ['tab']
    if (navItem === tab) {
      classes.push('selected')
    }
    if (hasBuildValidationErrors() && tab !== 'build') {
      classes.push('disabled')
    }
    if (isEditingTemplate && hasTemplateValidationErrors() && tab !== 'template') {
      classes.push('disabled')
    }
    return classes.join(' ')
  }

  return <div className='row'>
    <div className='tabs column'>
      <div className="language-selector">
        <LanguageSelector />
      </div>
      { isEditingTemplate &&
        <div className={tabClasses('template')} onClick={() => changeTab('template')}>
          Template
          {hasTemplateValidationErrors() && <span className="warning-icon"><SvgIconsWarning /></span>}
        </div>
      }
      { <div className={tabClasses('setup')} onClick={() => changeTab('setup')}>
        Setup
        {hasSetupValidationErrors() && <span className="warning-icon"><SvgIconsWarning /></span>}
        </div>
      }
      { <div className={tabClasses('build')} onClick={() => changeTab('build')}>
        Build
        {hasBuildValidationErrors() && <span className="warning-icon"><SvgIconsWarning /></span>}
      </div>}
      <div className={tabClasses('preview')} onClick={() => changeTab('preview')}>Preview</div>

    </div>
  </div>
}
